module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_05.2bfd7bbf.jpg";